import { useAsset } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';

// import { MOCK_IN_GRID_ASSETS } from '../__mocks__/mockInGridAssets'; // for testing only
import {
  getEligibleAssets,
  getMergedProductsAndAssets,
} from '../utils/inGridAssets';

import useBuilderConstructorGridInputs from './useBuilderConstructorGridInputs';
import useNumGridCols from './useNumGridCols';

const useInGridAssets = ({ products = [] }) => {
  const numGridCols = useNumGridCols();
  const { isMobile } = useBreakpoint();

  const { assetContainer } = useBuilderConstructorGridInputs();
  const gridAssetContainerDesktop = assetContainer?.gridAssetContainer;
  const gridAssetContainerMobile =
    assetContainer?.gridAssetContainerMobile || gridAssetContainerDesktop;
  const gridAssetContainer = isMobile
    ? gridAssetContainerMobile
    : gridAssetContainerDesktop;

  // const gridAssetContainer = 'CPTest_Grid_Banner_1'; // for testing only -- 7 assets with video,
  const gridAssetContainerObj = useAsset(gridAssetContainer, {
    multi: true,
  });

  const assets = gridAssetContainerObj?.data?.assets || [];
  // const assets = MOCK_IN_GRID_ASSETS; // for testing only -- multi-row assets

  const { assetCellReservationMap, eligibleAssets } = getEligibleAssets({
    assets,
    numGridCols,
  });

  const mergedAssetsAndProducts = getMergedProductsAndAssets({
    products,
    numGridCols,
    eligibleAssets,
    assetCellReservationMap,
  });

  return {
    inGridAssets: eligibleAssets,
    assetCellReservationMap,
    mergedAssetsAndProducts,
  };
};

export default useInGridAssets;
